import { LogicContext } from '@/logic/main/types';
import { startPersonalizedBanners } from '@/model/personalizedBanners/kraken';

export const initializePersonalizedBanners = async (
  personalizedBanners: LogicContext['personalizedBanners']
) => {
  try {
    personalizedBanners &&
      personalizedBanners.length &&
      (await startPersonalizedBanners(personalizedBanners));
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const initializePersonalizedBannersWithContext = async (
  context: LogicContext
) => {
  return await initializePersonalizedBanners(context.personalizedBanners);
};
